export const getTripFilters = (state: App.State) => {
  return state.tripPlanner.selectedSubFilters
}
